<template>
  <div class="filter-container">
    <div class="filter-header" @click="showFilter = !showFilter">
      <div class="filter-title">
        <i class="fa fa-filter" aria-hidden="true"></i>
        フィルター設定
      </div>
      <a class="text--underline">
        <i class="fa" :class="showFilter ? 'fa-caret-up' : 'fa-caret-down'" aria-hidden="true"></i>
        {{ showFilter ? '閉じる' : '開く' }}
      </a>
    </div>
    <div class="filter-content" :class="{ 'is-open': showFilter }">
        <div class="flexbox gap-20">
          <div class="filter-keyword">
            <span class="search-icon-left">🔎</span>
            <input type="text" class="search-input" v-model="search" @keyup.enter="handleFilter" placeholder="ASIN、SKU、FNSKU、商品名" autocomplete="off">
            <button class="clear-search" @click="clearSearch()">✕</button>
          </div>
          <div class="filter-actions">
            <button class="btn btn-primary mr-r-10" @click="handleFilter()">
              <i class="fa fa-search" aria-hidden="true"></i> 検索
            </button>
            <button class="btn" @click="resetFilters()">
              <i class="fa fa-undo" aria-hidden="true"></i> すべてクリア
            </button>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-box filter-status">
            <div class="font-bold mr-b-10">ステータス</div>
            <div class="box-options">
              <div
                v-for="i in statusOptions"
                :key="i.id"
                :class="{ 'active': filters.judgmentStatus.includes(i.id) }"
                class="box-option"
                @click="handleSelectStatus(i)"
              >
                {{ i.text }}
              </div>
            </div>
          </div>

          <div class="filter-box filter-stock">
            <div class="font-bold mr-b-10">在庫数</div>
            <div class="box-options">
              <div
                v-for="i in stockOptions"
                :key="i.id"
                :class="{ 'active': filters.stockStatus.includes(i.id) }"
                class="box-option"
                @click="handleSelectStock(i)"
              >
                {{ i.text }}
              </div>
            </div>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-box filter-warehouse">
            <div class="font-bold mr-b-10">表示する倉庫</div>
            <div class="box-options">
              <div
                v-for="i in arrWarehouse"
                :key="i.id"
                :class="{ 'active': filters.warehouse.includes(i.id) }"
                class="box-option"
                @click="handleSelectWarehouse(i)"
              >
                {{ i.text }}
              </div>
            </div>
          </div>

          <div class="filter-box">
            <div class="font-bold mr-b-10">受取金額</div>
            <div class="box-options">
              <div>
                <toggle-button
                  v-model="filters.amountReceived"
                  :labels="{checked: 'ON', unchecked: 'OFF'}"
                  :height=30
                  :width=62
                  :sync="true"
                  @change="handleFilter"
                />
                <span class="mr-l-10">Amazon倉庫の受取金額がSTOCKCREW倉庫より低い商品</span>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
  data () {
    return {
      showFilter: true,
      search: '',
      statusOptions: [
        { id: '審査中', text: '審査中' },
        { id: '出品中', text: '出品中' },
        { id: '停止中', text: '停止中' },
        { id: '審査NG', text: '審査NG' },
        { id: '出品NG', text: '出品NG' }
      ],
      stockOptions: [
        { id: 'in', text: '在庫あり' },
        { id: 'out', text: '在庫なし' }
      ],
      arrWarehouse: [
        { id: 'Amazon', text: 'Amazon倉庫' },
        { id: 'salmonSc', text: 'STOCKCREW倉庫' }
      ]
    }
  },
  created () {
    this.$store.commit('loadProductFilters', { storageKey: this.filterStorageKey })
  },
  computed: {
    filters () {
      return {
        ...this.$store.getters.getProductFilters
      }
    },
    filterStorageKey () {
      return `${this.$store.getters.getUser.sellerId}-productFilters`
    }
  },
  methods: {
    clearSearch () {
      this.search = ''
      this.handleFilter()
    },
    handleSelectStatus (i) {
      const index = this.filters.judgmentStatus.indexOf(i.id)
      if (index === -1) {
        this.filters.judgmentStatus.push(i.id)
      } else {
        this.filters.judgmentStatus.splice(index, 1)
      }
      this.handleFilter()
    },
    handleSelectStock (i) {
      const index = this.filters.stockStatus.indexOf(i.id)
      if (index === -1) {
        this.filters.stockStatus.push(i.id)
      } else {
        this.filters.stockStatus.splice(index, 1)
      }
      this.handleFilter()
    },
    handleSelectWarehouse (i) {
      const index = this.filters.warehouse.indexOf(i.id)
      if (index === -1) {
        this.filters.warehouse.push(i.id)
      } else {
        this.filters.warehouse.splice(index, 1)
      }
      this.handleFilter()
    },
    handleFilter () {
      this.$store.commit('saveProductFilters', {
        data: {...this.filters},
        storageKey: this.filterStorageKey
      })
      this.$emit('handleFilter', this.search)
    },
    resetFilters () {
      this.search = ''
      this.$emit('resetFilters')
      this.$emit('handleFilter', this.search)
    }
  }
}
</script>
<style scoped>
.filter-container {
  background-color: #f2f7fa;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
}
.filter-title {
  font-size: 20px;
  font-weight: bold;
  .fa {
    font-size: 24px;
    color: #286090;
  }
}

.filter-row {
  display: flex;
  gap: 15px;
}
.filter-keyword {
  flex: 1;
  position: relative;
  min-width: 280px;
}

.search-icon-left {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.4);
  font-size: 20px;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 6px;
  padding-left: 40px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 15px;
  color: #000;
}

.search-input:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.12);
  border-color: #0066ff;
  box-shadow: 0 0 0 4px rgba(0, 102, 255, 0.1);
}

.clear-search {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 18px;
  padding: 4px;
  opacity: 0;
  transition: all 0.3s ease;
}

.search-input:not(:placeholder-shown)+.clear-search {
  opacity: 1;
}

.clear-search:hover {
  color: #000;
}

.filter-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.filter-content.is-open {
  max-height: 1000px;
}

.filter-box {
  flex: 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
}

.filter-actions {
  margin-left: auto;
}

.box-options {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-left: 30px;
  align-items: center;
}

.box-option {
  padding: 5px 10px;
  border: 1px solid #e5e7eb;
  background-color: #e5e7eb;
  border-radius: 4px;
  cursor: pointer;
}

.box-option.active {
  background-color: rgb(111 199 141);
  border-color: rgb(117, 199, 145);
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
/* Tablet */
@media (max-width: 1024px) {
  .filter-row {
    flex-wrap: wrap;
  }

  .filter-box {
    min-width: 280px;
    flex: 1 1 45%;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .filter-container {
    padding: 15px;
  }

  .filter-title {
    font-size: 18px;
  }

  .filter-row {
    flex-direction: column;
    gap: 10px;
  }

  .filter-box {
    width: 100%;
  }

  .box-options {
    flex-wrap: wrap;
    gap: 8px;
    margin-left: 0;
  }

  .box-option {
    font-size: 13px;
    padding: 6px 8px;
  }

  .filter-keyword {
    width: 100%;
  }

  .search-input {
    font-size: 14px;
    padding: 8px 8px 8px 36px;
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .filter-container {
    padding: 12px;
  }

  .filter-title {
    font-size: 16px;
  }

  .box-option {
    font-size: 12px;
    padding: 5px 6px;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/productsNew/Search.vue